import createNetworkingClient from 'utils/networking-client';

// Prepopulated files have unique_id
// while uploaded files have uuid, so we want to return one of them
export const normalizeId = (file) => file.unique_id || file.uuid;

// Active has snake_case while React files use camelCase
export const normalizeMediaType = (file) => file.media_type || file.mediaType;

// Check if media is an Image or a Video
export const getMediaType = (file) => (/video/.test(file.type) ? 2 : 1);

// TODO: Look into crypto UUID potentially
// For each new file, create a uuid for it that will be used as unique_id
export const getUuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

// Process file and create thumbnail from the video drawn on a canvas
// Returns a preview url
export const getThumbnailPreviewUrl = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const mediaType = getMediaType(file);

    // Image
    if (mediaType === 1) {
      resolve(url);
      return;
    }
    // Video
    const video = document.createElement('video');
    video.muted = true;
    video.src = url;
    video.preload = 'metadata';
    video.playsInline = true;

    video.addEventListener('loadeddata', function() {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext('2d')
        .drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(function(blob) {
        const urlBlob = URL.createObjectURL(blob);
        resolve(urlBlob);
      }, 'image/png');
      video.pause();
    });
    video.play();
  });

// Return URL that will specify where to store the media
export const getMediaUrl = async (file, uuid, athleteId) => {
  const path = `/photos/metadata`;
  const mediaType = getMediaType(file);

  try {
    const result = await createNetworkingClient().put(path, {
      athlete_id: athleteId,
      uuid,
      taken_at: file.lastModified,
      media_type: mediaType
    });

    return result;
  } catch (error) {
    return {
      error: {
        message: `${error.name}: ${error.message}`,
        debug: {
          path
        }
      }
    };
  }
};

// Store media at given URL
export const storeMedia = async (data, file, onProgress) => {
  const { uri, header } = data;

  try {
    const result = await createNetworkingClient().put(uri, file, {
      headers: { 'Content-Type': header['Content-Type'] },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.loaded / progressEvent.total) * 100;
        onProgress(progress);
      },
      timeout: 600000 // 10 mins
    });
    return result;
  } catch (error) {
    return {
      error: {
        message: `${error.name}: ${error.message}`,
        debug: {
          uri
        }
      }
    };
  }
};

export default {
  normalizeId,
  normalizeMediaType,
  getMediaType,
  getUuid,
  getThumbnailPreviewUrl,
  getMediaUrl,
  storeMedia
};
